module.exports = "https://dashboard.cdn.gifty.nl/6114/images/emoti-2.png?8cdabb02edd1722c4b3128c693e113cd";